// extracted by mini-css-extract-plugin
module.exports = {"component":"linear-loading-timer-component--1VELo"};